import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

declare global {
    interface Window {
        Pusher: typeof Pusher;
        Echo: Echo;
    }
}

window.Pusher = Pusher;

const useTLS = window.location.protocol === 'https:';

const echo = new Echo({
    broadcaster: 'reverb',
    key: import.meta.env.VITE_REVERB_APP_KEY ?? 'quantix-key',
    // Connect to the same host — /app/{key} is the Pusher protocol default,
    // routed to the Reverb service by nginx without any path rewriting
    wsHost: window.location.hostname,
    wsPort: useTLS ? 443 : 80,
    wssPort: 443,
    forceTLS: useTLS,
    enabledTransports: ['ws', 'wss'],
    // Cookie-based Sanctum auth — browser sends session cookie automatically
    authEndpoint: '/api/v1/broadcasting/auth',
    auth: {
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
    },
    withCredentials: true,
});

export default echo;
